/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';

interface ILink {
  icon?: IconDefinition;
  text?: string;
  iconColor?: string;
  link: string;
}

export const NewTabLink = (props: ILink & Partial<HTMLLinkElement>): JSX.Element => {
  const {icon, className, text, link, iconColor = 'white'} = props;

  return (
    <a
      rel="noopener noreferrer"
      target="_blank"
      href={link}
      className={className}
    >
      {icon && <FontAwesomeIcon icon={icon} style={{color: iconColor}} />}
      {text}
    </a>
  );
};

export default NewTabLink;